exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".play-pause {\n  grid-area: playPause;\n}", ""]);

